import React from 'react';
import LoginWithAmazon from "../integrations/LoginWithAmazon";

export function Login() {
    return (
        <>
            <div className="ui basic modal" id={"loginModal"}>
                <LoginWithAmazon/>
            </div>
        </>
    )
}
